import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule as PrimeTooltipModule } from 'primeng/tooltip';
import { TooltipComponent } from './tooltip/tooltip.component';

@NgModule({
  declarations: [TooltipComponent],
  imports: [CommonModule, PrimeTooltipModule],
  exports: [TooltipComponent],
})
export class TooltipModule {}
